import { get } from 'lodash';
import React, { Component } from 'react';
import { H4 } from '@upsolve/ui';

import ChatBubbleIcon from '../../../static/images/icon-chat-bubble.svg';
import HintCard from './styled/HintCard.div';
import HintWrapper from './styled/HintWrapper.div';
import P from '../Type/Paragraph.p';
import SCREENER_CTA_TYPES from '../analytics/screenerCtaTypes'
import ScreenerButton from './styled/ScreenerButton.button';
import Wrapper from './styled/Wrapper.div';
import getScreenerUrl from '../Links/getScreenerUrl';
import { withAmp } from '../AMP/AmpContext';
import { ButtonLink } from '../analytics/LinksWithOnClick';
import trackComponentAction from '../analytics/trackComponentAction';
import trackComponentImpression from '../analytics/trackComponentImpression';

const trackingProps = {
  componentName: 'ChatWidget',
  componentVersion: 0,
};

/**
 * ChatWidget
 * - v0: CTA for screener. Copy about emotion/community.
 *
 * @component
 * @version 0
 */
class ChatWidget extends Component {
  state = {
    show: false,
    hint: false,
    filer: {
      name: null,
      email: null,
      phoneNumber: null,
      zipcode: null,
    },
    success: false,
    error: null,
    submitted: false,
  }

  componentDidMount() {
    // Hinting
    // - Start Timer (But don't hint if already hinted recently)
    if (window != null && (localStorage.getItem('Upsolve.widgetHinted') == null
      || (Number(localStorage.getItem('Upsolve.widgetHinted')) + 20000) < new Date().getTime())) {
      setTimeout(() => {
        this.show({ hint: true });
      }, 10000);
    }
    // - Show when scrolling
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (!this.state.show) {
      this.show();
      return;
    }
  };

  show(moreState) {
    this.setState({ ...moreState, show: true });
    // When shown (aka visible), track impression
    trackComponentImpression(trackingProps);
  }

  hideHint() {
    this.setState({ hint: false });
  }

  async submitHelper() {
    // Don't run if we've already submitted
    if (this.state.success === true) return;
    // Otherwise try it out
    this.setState(prevState => ({ ...prevState, submitted: true }));
    try {
      await fetch(new Request('https://hooks.slack.com/services/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', {
        method: 'POST',
        body: JSON.stringify({
          channel: '#feed-not-users',
          username: 'NotAUser',
          icon_emoji: ':no_good:',
          text: `*Not Interested/Confused:* ${this.state.feedback}`,
        })
      }))
      this.setState(prevState => ({ ...prevState, error: null, success: true, submitted: false }));
    } catch (e) {
      this.setState(prevState => ({
        ...prevState,
        error: get(e.response, 'data.error') || { message: 'An error was hit, please try submitting again.' },
        submitted: false,
      }));
    }
  }

  render() {
    const { amp, contentGroup } = this.props;
    const screenerUrl = getScreenerUrl({ cta: SCREENER_CTA_TYPES.CHAT_WIDGET, contentGroup });

    return amp === true
      ? (
        <a href={screenerUrl}>
          <ScreenerButton className="slide-in">
            <ChatBubbleIcon />
            <a href={screenerUrl}>{this.props.persistentCtaText || 'Get Free Help'}</a>
          </ScreenerButton>
        </a>
      )
      : (
        <Wrapper className={this.props.showPersistentCta !== true ? 'hide' : ''}>
          <HintWrapper className={`${this.state.hint === true ? 'show-hint' : ''}`}>
            <div className="hint__author" />
            <div
              className="hint__clear"
              onClick={(e) => {
                e.preventDefault();
                this.hideHint(true);
              }}
            >
              Close
            </div>
            <HintCard>
              <H4>Considering Bankruptcy?</H4>
              <div className="value-props">
                <P>
                  <b>Try our 100% free tool that thousands of low-income families across the country have used to file bankruptcy themselves.</b> We are funded by Harvard University, will never ask you for a credit card, and you can stop at any time.
                </P>
                <div>
                  <ButtonLink
                    size="lg"
                    aria-busy="false"
                    href={screenerUrl}
                    onClick={() => trackComponentAction({ ...trackingProps, actionId: 'chatWidget.card.screenerNavigation', actionMethod: 'click' })}
                  >
                    Explore Free Tool
                  </ButtonLink>
                </div>
              </div>
            </HintCard>
          </HintWrapper>
          {this.state.hint === false && (
            <ScreenerButton
              as="a"
              href={screenerUrl}
              aria-busy="false"
              aria-label={this.props.persistentCtaText || 'Get Free Help'}
              className={this.state.show === true ? 'slide-in' : ''}
              onClick={(ev) => {
                ev.preventDefault();
                trackComponentAction({ ...trackingProps, actionId: 'chatWidget.button.screenerNavigation', actionMethod: 'click' });
                window.location.href = screenerUrl;
              }}
            >
              <ChatBubbleIcon />
              {this.props.persistentCtaText || 'Get Free Help'}
            </ScreenerButton>
          )}
        </Wrapper>
      );
  }
}

export default withAmp(ChatWidget);
